export default __webpack_public_path__ + "assets/5e3e9ce857164723fc394a15f48b8c0e.png";